export default "images/case.png";